import { Api } from 'api';
import { callApi } from 'root/appSaga';
import { takeEvery, put, all } from 'redux-saga/effects';
import { generateAllQueryParams, getColumnFilter } from 'myParkdUtils/utils';
import { isChildFDRRight } from 'myParkdUtils/utils';
import { SessionDTOExtended, SessionsApiResponse, SagaGenerator } from 'types';
import { ColumnFilter } from '@tanstack/react-table';
import { historicalSessionsSliceActions } from './historicalSessionsSlice';
import { activeSessionsSliceActions } from './activeSessionsSlice';
import { offstreetSessionsSliceActions } from './offstreetSessionsSlice';
import { captureMessageWithError } from 'sentryTools';
import { captureException } from '@sentry/react';


export function* companySessionsSaga(): SagaGenerator {
    return yield all([
        takeEvery(historicalSessionsSliceActions.getHistoricalSessions, getHistoricalSessions),
        takeEvery(activeSessionsSliceActions.getActiveSessions, getActiveSessions),
        takeEvery(offstreetSessionsSliceActions.getOffstreetSessions, getOffstreetSessions)
    ]);
}

export function* getHistoricalSessions(params: ReturnType<typeof historicalSessionsSliceActions.getHistoricalSessions>): SagaGenerator {
    try {
        const queryParams = generateAllQueryParams(params.payload);
        const historicalSessions: SessionsApiResponse = yield callApi(Api.getHistoricalSessions, queryParams);

        yield put(historicalSessionsSliceActions.getHistoricalSessionsCompleted({
            sessions: historicalSessions.sessions.filter((session: SessionDTOExtended) => !isChildFDRRight(session)),
            totalPages: historicalSessions.totalPages,
            totalElements: historicalSessions.totalElements,
        }));
    } catch (error) {
        console.log('failure on getHistorical sessions');
        console.debug({ params });
        console.error({ error });
        captureMessageWithError('getHistoricalSessions() failed', error);
        yield put(historicalSessionsSliceActions.getHistoricalSessionsError({ error }));
    }
}

export function* getActiveSessions(params: ReturnType<typeof activeSessionsSliceActions.getActiveSessions>): SagaGenerator {
    try {
        const licensePlateFilter = getColumnFilter(params.payload.filters!, 'licensePlate');
        const activeSessionsFilters: ColumnFilter[] = licensePlateFilter ? [licensePlateFilter] : [];

        const payload = { ...params.payload, filters: activeSessionsFilters };
        const queryParams = generateAllQueryParams(payload);

        const activeSessions = yield callApi(Api.getActiveSessions, queryParams);
        yield put(activeSessionsSliceActions.getActiveSessionsCompleted(activeSessions));
    } catch (error) {
        console.error({ error });
        captureMessageWithError('getActiveSesssions() failed', error);
        yield put(activeSessionsSliceActions.getActiveSessionsError({ error }));
    }
}

export function* getOffstreetSessions(params: ReturnType<typeof offstreetSessionsSliceActions.getOffstreetSessions>): SagaGenerator {
    try {
        const queryParams = generateAllQueryParams(params.payload);
        const offstreetSessions: SessionsApiResponse = yield callApi(Api.getOffstreetSessions, queryParams);

        yield put(offstreetSessionsSliceActions.getOffstreetSessionsCompleted({
            sessions: offstreetSessions.sessions,
            totalPages: offstreetSessions.totalPages,
            totalElements: offstreetSessions.totalElements,
        }));
    } catch (error) {
        //console.error({ error });
        captureException(error, { extra: { msg: 'getOffstreetSessions() failed' } });
        //captureMessageWithError('getOffstreetSessions() failed', error);
        yield put(offstreetSessionsSliceActions.getOffstreetSessionsError({ error }));
    }
}
